import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  isLegacyLiveChatEnabled,
  LIVE_CHAT_V2_PATH,
} from "../../config/featureFlags";

/**
 * Keeps the legacy Live Chat page available only when explicitly enabled.
 * When disabled, `/Live` redirects to ChatV2 (`/chat`).
 */
export default function LegacyLiveChatGuard({ children }) {
  const location = useLocation();

  if (!isLegacyLiveChatEnabled) {
    return (
      <Navigate
        to={`${LIVE_CHAT_V2_PATH}${location.search}${location.hash}`}
        replace
      />
    );
  }

  return children;
}
